import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export interface IntegrationConfig {
  name: string;
  configured: boolean;
  write_enabled?: boolean | null;
  base_url?: string | null;
  auto_sync_minutes?: number | null;
  cache_ttl_minutes?: number | null;
  fields_pulled?: string[] | null;
  discovered_fields?: Record<string, string | null> | null;
  project_keys?: string[] | null;
  extra?: Record<string, unknown> | null;
}

export interface SchedulerJob {
  name: string;
  interval_minutes: number;
  integration: string;
}

export interface SchedulerConfig {
  weekdays_only: boolean;
  timezone: string;
  jobs: SchedulerJob[];
}

export interface FeatureFlag {
  key: string;
  label: string;
  enabled: boolean;
  source: "env" | "app_settings" | "derived";
  notes?: string | null;
}

export interface SystemConfig {
  integrations: IntegrationConfig[];
  scheduler: SchedulerConfig;
  feature_flags: FeatureFlag[];
  db_path: string;
  api_prefix: string;
  deploy_env: string;
  backup_configured: boolean;
}

export function useSystemConfig() {
  return useQuery<SystemConfig>({
    queryKey: ["system", "config"],
    queryFn: () => api.get("/system/config").then((r) => r.data),
    // Field discovery hits Jira's API. Cache aggressively — config
    // changes are rare and the user can always reload the page.
    staleTime: 5 * 60_000,
  });
}
